import React from 'react';

const SliderArrow = ({ style, onClick, customClass }) => {
  return (
    <div className={customClass} style={{ ...style, display: 'block' }} onClick={onClick} />
  )
}

export default SliderArrow;